export const DEPENDENCY_HOVER_NUDGE_STEP = 'DEPENDENCY_HOVER_NUDGE_STEP';
export const DEPENDENCY_DETAILS_ICON_NUDGE_STEP = 'DEPENDENCY_DETAILS_ICON_NUDGE_STEP';
export const DEPENDENCY_UNLINK_ICON_NUDGE_STEP = 'DEPENDENCY_UNLINK_ICON_NUDGE_STEP';
